import React from 'react'
//CSS
import styles from './Routes.module.css';

const QualityCalendar = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Quality Calendar</h1>
      </div>
      <div className={styles.body}>

      </div>
    </div>
  )
}

export default QualityCalendar